var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      







































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"dialog-padding\" overlay=\"$ctrl.loading\"\u003E\u003Ch1 class=\"center\"\u003EUser Groups\u003C\u002Fh1\u003E\u003Ch2 class=\"center\"\u003E{{ $ctrl.employee_id }} | {{ $ctrl.employee.vorname || $ctrl.employee.firstname }}, {{ $ctrl.employee.name || $ctrl.employee.lastname}}\u003C\u002Fh2\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-6 small-6 columns\" ng-repeat=\"user_group in $ctrl.user_groups\"\u003E\u003Cdiv class=\"checkbox schema-form-checkbox\"\u003E\u003Cinput type=\"checkbox\" id=\"employerCheckbox{{user_group.name}}\" ng-model=\"user_group.has_group\" ng-change=\"$ctrl.changeRole($ctrl.employee_id, user_group.name)\" ng-disabled=\"!$ctrl.canEditGroup(user_group) || user_group.is_disabled\"\u003E\u003Clabel for=\"employerCheckbox{{user_group.name}}\"\u003E\u003Cspan\u003E{{user_group.display}}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"user_group.name === 'employer' &amp;&amp; $ctrl.iAmEmployer\"\u003E\u003Cspan\u003E(\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"id in $ctrl.employer_customer_ids track by $index\"\u003E \u003Cspan ng-if=\"$index === 0\"\u003E{{ id }} \u003C\u002Fspan\u003E\u003Cspan ng-if=\"$index !== 0\"\u003E{{', ' + id }} \u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E)\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$ctrl.lodash.isEmpty($ctrl.employee_customer_specific_groups, true)\"\u003E\u003Ch5\u003ECustomer Specific Roles \u003C\u002Fh5\u003E\u003Cdiv class=\"xsmall-6 small-6 columns\" ng-repeat=\"(group_name, group) in $ctrl.employee_customer_specific_groups\"\u003E\u003Cdiv class=\"checkbox schema-form-checkbox\"\u003E\u003Clabel\u003E\u003Cspan\u003E{{ $ctrl.customer_specific_groups[group_name].display }}: \u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"customer_id in group track by $index\"\u003E\u003Cspan ng-if=\"$index === 0\"\u003E{{ customer_id }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$index !== 0\"\u003E{{', ' + customer_id }}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.updateUserGroups()\"\u003ESpeichern        \u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;